






import { Vue, Component, Prop } from "vue-property-decorator";

@Component({
    name: 'CloseButton'
})
export default class CloseButton extends Vue {
    @Prop({default: 'dark'}) theme: string;
    @Prop({ default: () => ({ width: 13, height: 13 }) }) params: { width: number; height: number }

    get iconStyle() {
        return {
            width: this.params.width,
            height: this.params.height
        }
    }

    get themeClass() {
        return this.theme === 'dark' ? this.$s.closeButtonDark : this.$s.closeButtonWhite
    }

    get $s() {
        return this.$style
    }
}

